import { colors, fontSize, size } from "@styles/theme"
import styled from '@emotion/styled'
import { PiArrowRightBold, PiCheckBold } from "react-icons/pi"
import { Emoji } from 'emoji-picker-react'
import { Button } from "@mui/material"

const StatusButton = styled(Button)`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: ${size(2.25)} ${size(2)} ${size(2.25)} ${size(3)};
  border: 2px solid white;
  border-radius: 100px;
  color: white;
`

const StatusText = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: ${size(1)};
`

const StatusTitle = styled.span`
  display: flex;
  align-items: center;
  line-height: ${size(2.5)};
  font-weight: bold;
  font-size: ${size(2)};
`

const StatusSubtext = styled.span`
  line-height: ${size(2)};
  font-size: ${size(1.7)};
  color: lightgrey;
  text-align: left;
  font-weight: normal;
`

const IndicatorContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: ${size(0)} ${size(1)};
  margin-left: ${size(1)};
  border-radius: 100px;

  font-size: ${fontSize('xs')};
  line-height: ${fontSize('sm')};
  background-color: ${colors.indicator()};

  color: black;
`

const ArrowContainer = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
`

const statusText = {
  browsing: '(Default) Checking the scene',
  right_now: 'Looking for sex/intimacy',
  meetup: 'Meeting up as friends',
  chatting: 'Talking online',
  romance: 'Looking for romantic dates',
}

const statusTextShort = {
  browsing: '(default)',
  right_now: 'sex/intimacy',
  meetup: 'as friends',
  chatting: 'talking online',
  romance: 'romantic dates',
}

const EmojiButton = ({ backgroundColor, borderColor, emoji, title, subtext, value, isCurrent, isNew, onClick, buttonStyles={}, hideArrow=false }) => {
  return (
    <StatusButton
      onClick={(e) => onClick(value, e)}
      style={{ backgroundColor, borderColor, ...buttonStyles }}>
      <Emoji unified={emoji} size="36" />
      <StatusText>
        <StatusTitle>
          {title}
          {isCurrent && <IndicatorContainer>current</IndicatorContainer>}
          {isNew && <IndicatorContainer>new</IndicatorContainer>}
        </StatusTitle>
        <StatusSubtext>{subtext}</StatusSubtext>
      </StatusText>
      <ArrowContainer>
        {!hideArrow && <PiArrowRightBold size={size(2)} />}
      </ArrowContainer>
    </StatusButton>
  )
}

const BrowsingButton = ({ afterSelect, isCurrent=false, isNew=false, isDisabled=false, buttonStyles={}, hideArrow=false }) => (
  <EmojiButton
    backgroundColor={colors.statusColors.browsing('lightRgba')(0.1)}
    borderColor={colors.statusColors.browsing('primary')}
    buttonStyles={buttonStyles}
    emoji='1f60e'
    title='Browsing'
    subtext={statusText['browsing']}
    value='browsing'
    isCurrent={isCurrent}
    isNew={isNew}
    hideArrow={hideArrow}
    onClick={(val) => !isDisabled && afterSelect(val)}
  />
)

const RightNowButton = ({ afterSelect, isCurrent=false, isNew=false, isDisabled=false, buttonStyles={}, hideArrow=false }) => (
  <EmojiButton
    backgroundColor={colors.statusColors.right_now('lightRgba')(0.1)}
    borderColor={colors.statusColors.right_now('primary')}
    buttonStyles={buttonStyles}
    emoji='1f440'
    title='Right Now'
    subtext={statusText['right_now']}
    value='right_now'
    isCurrent={isCurrent}
    isNew={isNew}
    hideArrow={hideArrow}
    onClick={(val) => !isDisabled && afterSelect(val)}
  />
)

const MeetupButton = ({ afterSelect, isCurrent=false, isNew=false, isDisabled=false, buttonStyles={}, hideArrow=false }) => (
  <EmojiButton
    backgroundColor={colors.statusColors.meetup('lightRgba')(0.1)}
    borderColor={colors.statusColors.meetup('primary')}
    buttonStyles={buttonStyles}
    emoji='1f91d'
    title='Meetup'
    subtext={statusText['meetup']}
    value='meetup'
    isCurrent={isCurrent}
    isNew={isNew}
    hideArrow={hideArrow}
    onClick={(val) => !isDisabled && afterSelect(val)}
  />
)

const ChattingButton = ({ afterSelect, isCurrent=false, isNew=false, isDisabled=false, buttonStyles={}, hideArrow=false }) => (
  <EmojiButton
    backgroundColor={colors.statusColors.chatting('lightRgba')(0.1)}
    borderColor={colors.statusColors.chatting('primary')}
    buttonStyles={buttonStyles}
    emoji='1f4ac'
    title='Chatting'
    subtext={statusText['chatting']}
    value='chatting'
    isCurrent={isCurrent}
    isNew={isNew}
    hideArrow={hideArrow}
    onClick={(val) => !isDisabled && afterSelect(val)}
  />
)

const RomanceButton = ({ afterSelect, isCurrent=false, isNew=false, isDisabled=false, buttonStyles={}, hideArrow=false }) => (
  <EmojiButton
    backgroundColor={colors.statusColors.romance('lightRgba')(0.1)}
    borderColor={colors.statusColors.romance('primary')}
    buttonStyles={buttonStyles}
    emoji='1f496'
    title='Romance'
    subtext={statusText['romance']}
    value='romance'
    isCurrent={isCurrent}
    isNew={isNew}
    hideArrow={hideArrow}
    onClick={(val) => !isDisabled && afterSelect(val)}
  />
)

export default EmojiButton
export { BrowsingButton, RightNowButton, MeetupButton, ChattingButton, RomanceButton, statusText, statusTextShort }
